import { useContext } from 'react'
import { OkeVipCustomerContext } from '../contexts/OkeVipCustomerContext'

export default function useVipCustomer(_vipID = null) {
  let { getVipPurchases, getVipPurchase, getVipTransactions, getVipAchievements, getVipProfile, setVipProfile, 
    setVipReferredBy, getCoupons, activateCoupon, claimCoupon, setUsePoints, payOrder, vipConnected, vipLoggedIn } = useContext(OkeVipCustomerContext)

  return {
    getVipPurchases, getVipPurchase, getVipTransactions, getVipAchievements, getVipProfile, setVipProfile, 
    setVipReferredBy, getCoupons, activateCoupon, claimCoupon, setUsePoints, payOrder, vipConnected, vipLoggedIn
  }
}
